import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BullhornNamespace, InveniasNamespace, SalesforceNamespace } from 'datasource-service-lib';
import { IDocumentType } from 'document-type-picker-lib';
import { Namespace } from 'enums-lib';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-attachment-restrictions',
  templateUrl: './attachment-restrictions.component.html',
  styleUrl: './attachment-restrictions.component.scss',
  standalone: false,
})
export class AttachmentRestrictionsComponent implements OnInit, OnDestroy {
  @Input() fileSection: any;
  @Input() namespace: Namespace | string;
  @Input() expandUp = false;
  @Input() set entityType(entityType: string) {
    this._entityType = entityType;
  }

  _entityType: string;
  documentTypes: IDocumentType[] = [];
  outputFileType: string;
  valid = true;
  sourceEntitiesLeafs: string[] = [];
  sourceEntitiesLeafsSub: Subscription;
  _attachmentSourceInitialised = false;

  ngOnInit(): void {
    this.setupSourceEntitiesLeafs();
  }

  ngOnDestroy(): void {
    this.sourceEntitiesLeafsSub?.unsubscribe();
  }

  get fileSectionConfig(): FormGroup {
    return this.fileSection.get('config') as FormGroup;
  }

  get showRestrictions(): boolean {
    const source = this.fileSectionConfig.get('attachmentUploadSource')?.value;
    return (
      source === SalesforceNamespace.name ||
      source === BullhornNamespace.name ||
      source === 'both' ||
      this.namespace === InveniasNamespace.name
    );
  }

  get title(): string {
    return this.namespace[0].toUpperCase() + this.namespace.slice(1) + ' files';
  }

  get isBullhorn(): boolean {
    return this.namespace === Namespace.bullhorn;
  }

  get isInvenias(): boolean {
    return this.namespace === Namespace.invenias;
  }

  get isSalesforce(): boolean {
    return this.namespace === Namespace.salesforce;
  }

  get showSourceEntityRestriction(): boolean {
    return this.isBullhorn || this.isSalesforce;
  }

  get showFileTypeRestrictions(): boolean {
    return !this.isSalesforce && (this._attachmentSourceInitialised || this.isInvenias);
  }

  get showFileAgeRestriction(): boolean {
    return this.isBullhorn || this.isSalesforce;
  }

  get attachmentSourceEntitiesControl() {
    return this.fileSectionConfig.controls['attachmentSourceEntities'];
  }

  attachmentSourceInitialised() {
    setTimeout(() => {
      this._attachmentSourceInitialised = true;
    });
  }

  private setupSourceEntitiesLeafs() {
    // old templates will not have a value for attachmentSourceEntities so use the template entity type
    const initialEntitySource = this.attachmentSourceEntitiesControl.value?.length
      ? this.attachmentSourceEntitiesControl.value
      : [this._entityType];
    this.sourceEntitiesLeafs = initialEntitySource.map((path: string) => path.split('.').pop());

    this.sourceEntitiesLeafsSub = this.attachmentSourceEntitiesControl.valueChanges.subscribe({
      next: (value: string[]) => {
        this.sourceEntitiesLeafs = value.map((path: string) => path.split('.').pop());
      },
    });
  }
}
